import { render, staticRenderFns } from "./ManageVisitsResultsDetail.vue?vue&type=template&id=21caa93d&"
import script from "./ManageVisitsResultsDetail.vue?vue&type=script&lang=js&"
export * from "./ManageVisitsResultsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ManageVisitsResultsDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('21caa93d', component.options)
    } else {
      api.reload('21caa93d', component.options)
    }
    module.hot.accept("./ManageVisitsResultsDetail.vue?vue&type=template&id=21caa93d&", function () {
      api.rerender('21caa93d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/CommercialManagement/ManageVisitsResultsDetail.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/CommercialManagement/ManageVisitsResultsDetail.vue
// module id = /SfT
// module chunks = 0